import {Swiper, SwiperSlide, useSwiper} from "swiper/react";
import {useEffect, useRef, useState} from "react";
import {getBaseImagePath} from "../Utils";
import ModelImageInterface from "../../../interfaces/model/ModelImageInterface";
import ModelVideoInterface from "../../../interfaces/model/ModelVideoInterface";
import BreadcrumbInterface from "../../../interfaces/core/BreadcrumbInterface";
import {Link, useNavigate} from "react-router-dom";
import ReactImageMagnify from 'react-image-magnify';
import {convertImageToSize, ImageSize} from "../../../utils/Image";
import CardMobilePopup from "./CardMobilePopup";

export default function Slider({images, videos = [], altString, breadcrumbs} : {images: ModelImageInterface[], videos?: ModelVideoInterface[], altString: string, breadcrumbs: BreadcrumbInterface[]}) {
    // грязный хак - без него не работают стрелки перемещения слайдов
    const [isLoop, setIsLoop] = useState(false);
    const [slideIndex, setSlideIndex] = useState(0);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [videoThumbnails, setVideoThumbnails] = useState<string[]>([]);

    const navigate = useNavigate();

    const swiperRef = useRef();

    const swiper = useSwiper();
    const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);

    useEffect(() => {
    const generateThumbnails = async () => {
    const thumbnails: string[] = [];
    for (const video of videos) {
        const thumbnail = await createVideoThumbnail(video.url);
        thumbnails.push(thumbnail);
    }
    setVideoThumbnails(thumbnails);
    };

    generateThumbnails();
}, [videos]);

    const createVideoThumbnail = (videoUrl: string): Promise<string> => {
    return new Promise((resolve) => {
    const videoElement = document.createElement('video');
    videoElement.src = videoUrl;
    videoElement.currentTime = 1;

    videoElement.addEventListener('loadeddata', () => {
        const canvas = document.createElement('canvas');
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;
        const context = canvas.getContext('2d');
        if (context) {
            context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            const thumbnail = canvas.toDataURL('image/png');
            resolve(thumbnail);
        }
    });

    videoElement.load();
    });
    };

    useEffect(() => {
        console.log(swiper)
    }, []);

    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        };

        const observerCallback: IntersectionObserverCallback = (entries) => {
            entries.forEach((entry) => {
                const video = entry.target as HTMLVideoElement;
                if (entry.isIntersecting) {
                    video.play();
                } else {
                    video.pause();
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        videoRefs.current.forEach(video => {
            if (video) observer.observe(video);
        });

        return () => {
            videoRefs.current.forEach(video => {
                if (video) observer.unobserve(video);
            });
        };
    }, [videos]);
    

    const handleImageClick = (index: number) => {
        if (window.innerWidth <= 991) {
            setSlideIndex(index);
            setIsPopupOpen(true);
        }
    };


    return (<div className="product__kv-slider">
        <a className="product__kv-all-image btn btn-primary" href="/" onClick={(event) => { event.preventDefault()}}><i
            className="ico ico-left ico-eye-black ico-color"></i>Весь образ</a>
        <div className="product__kv-slider__wrap">
            <div className="product__kv-slider-main">
                <Swiper
                    loop={isLoop}
                    spaceBetween={5}
                    slidesPerView={1}
                    onSlideChange={(p1:any) => {
                        console.log(p1?.activeIndex)
                    }}
                    onSwiper={ (swiper:any) => {
                        swiperRef.current = swiper
                    }}
                    breakpoints={{
                        992: {
                            slidesPerView: 2.3
                        }
                    }}
                >
            {videos.map((video, index) => (
                <SwiperSlide key={`video-${index}`} virtualIndex={images.length + index}>
                    <video
                    ref={el => videoRefs.current[index] = el}
                    muted
                    loop
                    autoPlay
                    playsInline
                    preload="none"
                    style={{ width: '100%' }}
                    >
                        <source src={video.url} type="video/mp4" />
                        Видео не поддерживается браузером
                    </video>
                </SwiperSlide>
            ))}  
                    {images.map((image, index) => <SwiperSlide key={image.url} virtualIndex={index}>
                        <a key={image.url} className="slide" href="/" onClick={(event) => { event.preventDefault(); handleImageClick(index); }}>
                            {/* <img  src={getBaseImagePath() + image.url} alt={altString + (index ? ' - ' + (index + 1) : '')}/> */}
                <ReactImageMagnify
                {...{
                    smallImage: {
                        alt: `${altString} - ${index + 1}`,
                        isFluidWidth: true,
                        src: getBaseImagePath() + image.url,
                    },
                    largeImage: {
                        src: getBaseImagePath() + convertImageToSize(image, ImageSize.ORIIGINAL).url,
                        width: 1200,
                        height: 1800,
                    },
                    className: 'custom-zoom',
                    style: {
                    cursor: 'zoom-in',
                    },
                    enlargedImagePosition: 'over', 
                    // isHintEnabled: true, 
                    // hintTextMouse: "Наведите для увеличения",
                    // hintTextTouch: "Наведите для увеличения",
                }}
            />
                        </a>
                    </SwiperSlide>)}
                </Swiper>


            </div>
            <div className="product__kv-slider-add desk">
            {videoThumbnails.map((thumbnail, index) => (
            <div key={`video-thumbnail-${index}`} className="slide">
                <img
                className={"pointer"}
                style={{ border: (slideIndex === index ? "1" : "0") + "px solid grey" }}
                onClick={() => {
                    // @ts-ignore
                swiperRef.current.slideTo(index);
                setSlideIndex(index);
                }}
                src={thumbnail}
                alt={`Video thumbnail ${index + 1}`}
                />
            </div>
                ))}
                {images.map((image, index) => <div key={image.url} className="slide"><img className={"pointer"} style={{border: (slideIndex === images.length + index ? "1" : "0") + "px solid grey" }} onClick={
                    () => {
                        // @ts-ignore
                swiperRef.current.slideTo(videos.length + index);
                setSlideIndex(videos.length + index);
                    }
                }
                    src={getBaseImagePath() + image.url} alt=""/></div>)}
            

            </div>
            <div className="product__kv-slider-controls desk">
                <div className="slick-btn slick-btn-prev" onClick={() => {
                    if(isLoop) {
                        // @ts-ignore
                        swiperRef.current.slidePrev()
                        setSlideIndex(slideIndex > 0 ? slideIndex-1 : images.length)
                    }else {
                        // @ts-ignore
                        swiperRef.current.slideTo(images.length)
                        setSlideIndex(images.length - 2)
                    }
                    setIsLoop(true)
                }}></div>
                <div className="slick-btn slick-btn-next" onClick={() => {
                    setIsLoop(true)
                    // @ts-ignore
                    swiperRef.current.slideNext()
                    setSlideIndex(slideIndex > images.length - 1 ? 0 : slideIndex+1)
                }}></div>
            </div>
            {breadcrumbs && breadcrumbs.map((breadcrumb) => <p>
            <a href={'/'} className="product__kv-back-page mob" onClick={(event) => {
                event.preventDefault()
                navigate(-1)
            }}><i className="ico ico-arrow-left-b"></i></a>
            </p>
        )}
        </div>
        <CardMobilePopup
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                initialSlideIndex={slideIndex}
                images={images}
                altString={altString}
            />
    </div>)
}